import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';

/**
 * Информация для задизейбленного поля.
 */

@Component({
    selector: 'app-form-disabled-info',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <lib-icon type="help" class="info" [size]="14" style="margin-bottom: -2px" appPopoverMessage [appPopoverMessage]="message"></lib-icon>
    `
})
export class FormDisabledInfoComponent {
    public message = `Данное поле недоступно для редактирования.<br>
В случае, если вы ошиблись, напишите на почту lab@lab365.ru текущий ИНН,
полное наименование организации и информацию, которую необходимо изменить (например, ИНН или Дату регистрации).`;
}
